import logo from '../../assets/SGN_04_25_2023_1682462832504.png'
import './logoboard.css'
import './navdashboard.css'
import './dashboard.css'
import menuView from './dashboard'
import Navdashboard from './navdashboard'
import burguer from '../../assets/icon-hamburger.svg'
function Logoboard(){
   
   
    return <div className="bg-logoboard">
        {/* <h2>DASH APP</h2> */}
        <img className='logoBgBoard' src={logo} alt="logo dash app" ></img>
        {/* <img  className='burgeur' src={burguer} alt="logo dash app" ></img> */}
        
    </div>
}

export default Logoboard